import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { IPriceItemList } from '~/utils/interface/priceItem';
import { handleGetPriceItems } from './priceItemsThunk';

export interface PriceItemState {
  selectPrices: Array<IPriceItemList>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  priceItems: Array<IPriceItemList>;
  selectedIds: Array<string>;
  priceItemId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: PriceItemState = {
  selectPrices: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  priceItems: [],
  priceItemId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const priceItemSlice = createSlice({
  name: 'priceItem',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changePriceItemId(state, action: PayloadAction<string>) {
      state.priceItemId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetPriceItems.pending, (_state, _action) => {})

      .addCase(handleGetPriceItems.fulfilled, (state, action) => {
        state.priceItems = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetPriceItems.rejected, (_state, _action) => {});
  },
});

export const priceItemActions = priceItemSlice.actions;

const priceItemReducer = priceItemSlice.reducer;
export default priceItemReducer;
